// eslint-disable-next-line import/prefer-default-export
export const FILTER_NAMES = {
  UNORDERED: "_UNORDERED",
  EMAIL: "email",
  NAME: "name",
  TITLE: "title",
};
